// /**
//  * Post Registration Cart Script
//  * Adds subscription product to cart after successful registration from member benefits page
//  */

// (function() {
//   'use strict';

//   // Subscription product handle
//   const SUBSCRIPTION_PRODUCT_HANDLE = 'subscription-product';

//   /**
//    * Fetch subscription product variant ID
//    */
//   async function getSubscriptionProductVariant() {
//     try {
//       const response = await fetch(`/products/${SUBSCRIPTION_PRODUCT_HANDLE}.js`);
      
//       if (!response.ok) {
//         console.error('Failed to fetch subscription product:', response.status);
//         return null;
//       }

//       const product = await response.json();
      
//       // Get the first available variant
//       const availableVariant = product.variants.find(v => v.available) || product.variants[0];
      
//       if (!availableVariant) {
//         console.error('No available variants found for subscription product');
//         return null;
//       }

//       return availableVariant.id;
//     } catch (error) {
//       console.error('Error fetching subscription product:', error);
//       return null;
//     }
//   }

//   /**
//    * Add product to cart
//    */
//   async function addToCart(variantId) {
//     try {
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1
//         })
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error('Failed to add to cart:', errorData);
//         return false;
//       }

//       const cartItem = await response.json();
//       console.log('Subscription product added to cart:', cartItem);
//       return true;
//     } catch (error) {
//       console.error('Error adding to cart:', error);
//       return false;
//     }
//   }

//   /**
//    * Update cart drawer/mini cart if available
//    */
//   function updateCartUI() {
//     // Dispatch cart update event
//     document.dispatchEvent(new CustomEvent('cart:updated'));
    
//     // Try to fetch and update cart drawer
//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(cart => {
//         // Update cart count if elements exist
//         const cartCountElements = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count]');
//         cartCountElements.forEach(el => {
//           if (el) {
//             el.textContent = cart.item_count;
//           }
//         });

//         // Trigger mini-cart refresh if available
//         const miniCart = document.querySelector('mini-cart');
//         if (miniCart && typeof miniCart.renderContents === 'function') {
//           fetch('/cart?sections=mini-cart,cart-icon-bubble')
//             .then(res => res.json())
//             .then(sections => {
//               const parsedState = {
//                 sections: {
//                   'mini-cart': sections['mini-cart'],
//                   'cart-icon-bubble': sections['cart-icon-bubble']
//                 }
//               };
//               miniCart.renderContents(parsedState);
//             })
//             .catch(err => console.error('Error updating mini cart:', err));
//         }
//       })
//       .catch(err => console.error('Error fetching cart:', err));
//   }

//   /**
//    * Check if customer is logged in
//    */
//   function isCustomerLoggedIn() {
//     // Check multiple ways to detect logged in customer
//     if (typeof window.customer !== 'undefined' && window.customer !== null) {
//       return true;
//     }
    
//     // Check if we're on account page (but not login/register)
//     const path = window.location.pathname;
//     const isOnAccountPage = path.includes('/account') && 
//                            !path.includes('/account/login') &&
//                            !path.includes('/account/register') &&
//                            !path.includes('/account/reset');
    
//     if (isOnAccountPage) {
//       // Check if customer data is available via DOM
//       const hasCustomerElements = document.querySelector('.customer.account') !== null;
//       return hasCustomerElements;
//     }
    
//     return false;
//   }

//   /**
//    * Main function to handle post-registration cart addition
//    */
//   async function handlePostRegistrationCart(attempts = 0) {
//     // Check if flag is set
//     const shouldAddSubscription = sessionStorage.getItem('addSubscriptionAfterRegister') === 'true';
    
//     if (!shouldAddSubscription) {
//       return;
//     }

//     // Prevent infinite retries
//     if (attempts > 10) {
//       console.warn('Max attempts reached for post-registration cart addition');
//       sessionStorage.removeItem('addSubscriptionAfterRegister');
//       sessionStorage.removeItem('fromMemberBenefits');
//       return;
//     }

//     // Check if user is logged in (registration was successful)
//     const isLoggedIn = isCustomerLoggedIn();

//     // Wait a bit for customer data to be available after redirect
//     if (!isLoggedIn) {
//       // Wait and check again (with exponential backoff)
//       const delay = Math.min(1000 * (attempts + 1), 5000);
//       setTimeout(() => handlePostRegistrationCart(attempts + 1), delay);
//       return;
//     }

//     // Customer is logged in - proceed with adding product to cart
//     // Clear the flag immediately to prevent duplicate runs
//     sessionStorage.removeItem('addSubscriptionAfterRegister');
//     sessionStorage.removeItem('fromMemberBenefits');

//     // Small delay to ensure page is fully loaded
//     await new Promise(resolve => setTimeout(resolve, 500));

//     // Fetch subscription product variant ID
//     const variantId = await getSubscriptionProductVariant();
    
//     if (!variantId) {
//       console.error('Could not get subscription product variant ID');
//       return;
//     }

//     // Check if product is already in cart
//     try {
//       const cartResponse = await fetch('/cart.js');
//       const cart = await cartResponse.json();
      
//       const alreadyInCart = cart.items.some(item => {
//         // Check if subscription product is already in cart by comparing variant ID
//         return item.variant_id === variantId || 
//                item.product_handle === SUBSCRIPTION_PRODUCT_HANDLE;
//       });
      
//       if (alreadyInCart) {
//         console.log('Subscription product already in cart');
//         return;
//       }
//     } catch (error) {
//       console.warn('Could not check cart:', error);
//     }

//     // Add product to cart
//     const added = await addToCart(variantId);
    
//     if (added) {
//       // Update cart UI
//       updateCartUI();
      
//       // Show success message (optional)
//       console.log('Subscription product successfully added to cart!');
//     }
//   }

//   // Run on page load
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', handlePostRegistrationCart);
//   } else {
//     // DOM already loaded
//     handlePostRegistrationCart();
//   }

//   // Also check after a short delay (in case of redirect)
//   setTimeout(handlePostRegistrationCart, 2000);
// })();

/**
 * Post Registration Cart Script
 * Adds subscription product to cart after successful registration from member benefits page
 */

// (function () {
//   'use strict';

//   // Subscription product handle
//   const SUBSCRIPTION_PRODUCT_HANDLE = 'subscription-product';

//   /**
//    * Fetch subscription product variant ID
//    */
//   async function getSubscriptionProductVariant() {
//     try {
//       const response = await fetch(`/products/${SUBSCRIPTION_PRODUCT_HANDLE}.js`);

//       if (!response.ok) {
//         console.error('Failed to fetch subscription product:', response.status);
//         return null;
//       }

//       const product = await response.json();

//       // Get the first available variant
//       const availableVariant = product.variants.find(v => v.available) || product.variants[0];

//       if (!availableVariant) {
//         console.error('No available variants found for subscription product');
//         return null;
//       }

//       return availableVariant.id;
//     } catch (error) {
//       console.error('Error fetching subscription product:', error);
//       return null;
//     }
//   }

//   /**
//    * Add product to cart
//    */
//   async function addToCart(variantId) {
//     try {
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1
//         })
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error('Failed to add to cart:', errorData);
//         return false;
//       }

//       const cartItem = await response.json();
//       console.log('Subscription product added to cart:', cartItem);
//       return true;
//     } catch (error) {
//       console.error('Error adding to cart:', error);
//       return false;
//     }
//   }

//   /**
//    * Update cart drawer/mini cart if available
//    */
//   function updateCartUI() {
//     // Dispatch cart update event
//     document.dispatchEvent(new CustomEvent('cart:updated'));

//     // Try to fetch and update cart drawer
//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(cart => {
//         // Update cart count if elements exist
//         const cartCountElements = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count]');
//         cartCountElements.forEach(el => {
//           if (el) {
//             el.textContent = cart.item_count;
//           }
//         });

//         // Trigger mini-cart refresh if available
//         const miniCart = document.querySelector('mini-cart');
//         if (miniCart && typeof miniCart.renderContents === 'function') {
//           fetch('/cart?sections=mini-cart,cart-icon-bubble')
//             .then(res => res.json())
//             .then(sections => {
//               const parsedState = {
//                 sections: {
//                   'mini-cart': sections['mini-cart'],
//                   'cart-icon-bubble': sections['cart-icon-bubble']
//                 }
//               };
//               miniCart.renderContents(parsedState);
//             })
//             .catch(err => console.error('Error updating mini cart:', err));
//         }
//       })
//       .catch(err => console.error('Error fetching cart:', err));
//   }

//   /**
//    * Check if customer is logged in
//    */
//   function isCustomerLoggedIn() {
//     // Check multiple ways to detect logged in customer
//     if (typeof window.customer !== 'undefined' && window.customer !== null) {
//       return true;
//     }

//     // Check if we're on account page (but not login/register)
//     const path = window.location.pathname;
//     const isOnAccountPage = path.includes('/account') &&
//       !path.includes('/account/login') &&
//       !path.includes('/account/register') &&
//       !path.includes('/account/reset');

//     if (isOnAccountPage) {
//       // Check if customer data is available via DOM
//       const hasCustomerElements = document.querySelector('.customer.account') !== null;
//       return hasCustomerElements;
//     }

//     return false;
//   }

//   /**
//    * Main function to handle post-registration cart addition
//    */
//   async function handlePostRegistrationCart(attempts = 0) {
//     // Check if flag is set
//     const shouldAddSubscription = sessionStorage.getItem('addSubscriptionAfterRegister') === 'true';

//     if (!shouldAddSubscription) {
//       return;
//     }

//     // Check if user just registered (not logged in)
//     const justRegistered = sessionStorage.getItem('justRegistered') === 'true';
//     const justLoggedIn = sessionStorage.getItem('justLoggedIn') === 'true';

//     // Also check referrer as backup - if came from register page, it's registration
//     const referrer = document.referrer || '';
//     const cameFromRegister = referrer.includes('/account/register');
//     const cameFromLogin = referrer.includes('/account/login') && !referrer.includes('/account/register');

//     // Only add subscription if user registered, NOT if they just logged in
//     // Check both sessionStorage flag and referrer for reliability
//     const isRegistration = (justRegistered || cameFromRegister) && !justLoggedIn && !cameFromLogin;

//     if (!isRegistration) {
//       // Clear flags if it was a login (not registration)
//       if (justLoggedIn || cameFromLogin) {
//         sessionStorage.removeItem('addSubscriptionAfterRegister');
//         sessionStorage.removeItem('fromMemberBenefits');
//       }
//       return;
//     }

//     // Prevent infinite retries
//     if (attempts > 10) {
//       console.warn('Max attempts reached for post-registration cart addition');
//       sessionStorage.removeItem('addSubscriptionAfterRegister');
//       sessionStorage.removeItem('fromMemberBenefits');
//       return;
//     }

//     // Check if user is logged in (registration was successful)
//     const isLoggedIn = isCustomerLoggedIn();

//     // Wait a bit for customer data to be available after redirect
//     if (!isLoggedIn) {
//       // Wait and check again (with exponential backoff)
//       const delay = Math.min(1000 * (attempts + 1), 5000);
//       setTimeout(() => handlePostRegistrationCart(attempts + 1), delay);
//       return;
//     }

//     // Customer is logged in - proceed with adding product to cart
//     // Clear the flag immediately to prevent duplicate runs
//     sessionStorage.removeItem('addSubscriptionAfterRegister');
//     sessionStorage.removeItem('fromMemberBenefits');

//     // Small delay to ensure page is fully loaded
//     await new Promise(resolve => setTimeout(resolve, 500));

//     // Fetch subscription product variant ID
//     const variantId = await getSubscriptionProductVariant();

//     if (!variantId) {
//       console.error('Could not get subscription product variant ID');
//       return;
//     }

//     // Check if product is already in cart
//     try {
//       const cartResponse = await fetch('/cart.js');
//       const cart = await cartResponse.json();

//       const alreadyInCart = cart.items.some(item => {
//         // Check if subscription product is already in cart by comparing variant ID
//         return item.variant_id === variantId ||
//           item.product_handle === SUBSCRIPTION_PRODUCT_HANDLE;
//       });

//       if (alreadyInCart) {
//         console.log('Subscription product already in cart');
//         return;
//       }
//     } catch (error) {
//       console.warn('Could not check cart:', error);
//     }

//     // Add product to cart
//     const added = await addToCart(variantId);

//     if (added) {
//       // Update cart UI
//       updateCartUI();

//       // Show success message (optional)
//       console.log('Subscription product successfully added to cart!');
//     }
//   }

//   // Run on page load
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', handlePostRegistrationCart);
//   } else {
//     // DOM already loaded
//     handlePostRegistrationCart();
//   }

//   // Also check after a short delay (in case of redirect)
//   setTimeout(handlePostRegistrationCart, 2000);
// })();


/**
 * Post Registration Cart Script
 * Adds subscription product to cart after successful registration from member benefits page
 */

// (function () {
//   'use strict';

//   // Subscription product handle
//   const SUBSCRIPTION_PRODUCT_HANDLE = 'subscription-product';

//   /**
//    * Fetch subscription product variant ID
//    */
//   async function getSubscriptionProductVariant() {
//     try {
//       const response = await fetch(`/products/${SUBSCRIPTION_PRODUCT_HANDLE}.js`);

//       if (!response.ok) {
//         console.error('Failed to fetch subscription product:', response.status);
//         return null;
//       }

//       const product = await response.json();

//       // Get the first available variant
//       const availableVariant = product.variants.find(v => v.available) || product.variants[0];

//       if (!availableVariant) {
//         console.error('No available variants found for subscription product');
//         return null;
//       }

//       return availableVariant.id;
//     } catch (error) {
//       console.error('Error fetching subscription product:', error);
//       return null;
//     }
//   }

//   /**
//    * Add product to cart
//    */
//   async function addToCart(variantId) {
//     try {
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1
//         })
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error('Failed to add to cart:', errorData);
//         return false;
//       }

//       const cartItem = await response.json();
//       console.log('Subscription product added to cart:', cartItem);
//       return true;
//     } catch (error) {
//       console.error('Error adding to cart:', error);
//       return false;
//     }
//   }

//   /**
//    * Update cart drawer/mini cart if available
//    */
//   function updateCartUI() {
//     // Dispatch cart update event
//     document.dispatchEvent(new CustomEvent('cart:updated'));

//     // Try to fetch and update cart drawer
//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(cart => {
//         // Update cart count if elements exist
//         const cartCountElements = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count]');
//         cartCountElements.forEach(el => {
//           if (el) {
//             el.textContent = cart.item_count;
//           }
//         });

//         // Trigger mini-cart refresh if available
//         const miniCart = document.querySelector('mini-cart');
//         if (miniCart && typeof miniCart.renderContents === 'function') {
//           fetch('/cart?sections=mini-cart,cart-icon-bubble')
//             .then(res => res.json())
//             .then(sections => {
//               const parsedState = {
//                 sections: {
//                   'mini-cart': sections['mini-cart'],
//                   'cart-icon-bubble': sections['cart-icon-bubble']
//                 }
//               };
//               miniCart.renderContents(parsedState);
//             })
//             .catch(err => console.error('Error updating mini cart:', err));
//         }
//       })
//       .catch(err => console.error('Error fetching cart:', err));
//   }

//   /**
//    * Check if customer is logged in
//    */
//   function isCustomerLoggedIn() {
//     // Check multiple ways to detect logged in customer
//     if (typeof window.customer !== 'undefined' && window.customer !== null) {
//       return true;
//     }

//     // Check if we're on account page (but not login/register)
//     const path = window.location.pathname;
//     const isOnAccountPage = path.includes('/account') &&
//       !path.includes('/account/login') &&
//       !path.includes('/account/register') &&
//       !path.includes('/account/reset');

//     if (isOnAccountPage) {
//       // Check if customer data is available via DOM
//       const hasCustomerElements = document.querySelector('.customer.account') !== null;
//       return hasCustomerElements;
//     }

//     return false;
//   }

//   /**
//    * Main function to handle post-registration cart addition
//    */
//   async function handlePostRegistrationCart(attempts = 0) {
//     // Check if flag is set
//     const shouldAddSubscription = sessionStorage.getItem('addSubscriptionAfterRegister') === 'true';

//     if (!shouldAddSubscription) {
//       return;
//     }

//     // Check if user just registered (not logged in)
//     const justRegistered = sessionStorage.getItem('justRegistered') === 'true';
//     const justLoggedIn = sessionStorage.getItem('justLoggedIn') === 'true';

//     // Also check referrer as backup - if came from register page, it's registration
//     const referrer = document.referrer || '';
//     const cameFromRegister = referrer.includes('/account/register');
//     const cameFromLogin = referrer.includes('/account/login') && !referrer.includes('/account/register');

//     // Only add subscription if user registered, NOT if they just logged in
//     // Check both sessionStorage flag and referrer for reliability
//     const isRegistration = (justRegistered || cameFromRegister) && !justLoggedIn && !cameFromLogin;

//     if (!isRegistration) {
//       // Clear flags if it was a login (not registration)
//       if (justLoggedIn || cameFromLogin) {
//         sessionStorage.removeItem('addSubscriptionAfterRegister');
//         sessionStorage.removeItem('fromMemberBenefits');
//       }
//       return;
//     }

//     // Prevent infinite retries
//     if (attempts > 10) {
//       console.warn('Max attempts reached for post-registration cart addition');
//       sessionStorage.removeItem('addSubscriptionAfterRegister');
//       sessionStorage.removeItem('fromMemberBenefits');
//       return;
//     }

//     // Check if user is logged in (registration was successful)
//     const isLoggedIn = isCustomerLoggedIn();

//     // Wait a bit for customer data to be available after redirect
//     if (!isLoggedIn) {
//       // Wait and check again (with exponential backoff)
//       const delay = Math.min(1000 * (attempts + 1), 5000);
//       setTimeout(() => handlePostRegistrationCart(attempts + 1), delay);
//       return;
//     }

//     // Customer is logged in - proceed with adding product to cart
//     // Clear the flag immediately to prevent duplicate runs
//     sessionStorage.removeItem('addSubscriptionAfterRegister');
//     sessionStorage.removeItem('fromMemberBenefits');

//     // Small delay to ensure page is fully loaded
//     await new Promise(resolve => setTimeout(resolve, 500));

//     // Fetch subscription product variant ID
//     const variantId = await getSubscriptionProductVariant();

//     if (!variantId) {
//       console.error('Could not get subscription product variant ID');
//       return;
//     }

//     // Check if product is already in cart
//     try {
//       const cartResponse = await fetch('/cart.js');
//       const cart = await cartResponse.json();

//       const subscriptionItem = cart.items.find(item => {
//         // Check if subscription product is already in cart by comparing variant ID or handle
//         return item.variant_id === variantId ||
//           item.product_handle === SUBSCRIPTION_PRODUCT_HANDLE;
//       });

//       if (subscriptionItem) {
//         // If quantity is more than 1, update it to 1
//         if (subscriptionItem.quantity > 1) {
//           await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//               'Accept': 'application/json'
//             },
//             body: JSON.stringify({
//               id: subscriptionItem.key,
//               quantity: 1
//             })
//           });
//           updateCartUI();
//         }
//         console.log('Subscription product already in cart with quantity 1');
//         return;
//       }
//     } catch (error) {
//       console.warn('Could not check cart:', error);
//     }

//     // Add product to cart
//     const added = await addToCart(variantId);

//     if (added) {
//       // Update cart UI
//       updateCartUI();

//       // Show success message (optional)
//       console.log('Subscription product successfully added to cart!');
//     }
//   }

//   // Run on page load
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', handlePostRegistrationCart);
//   } else {
//     // DOM already loaded
//     handlePostRegistrationCart();
//   }

//   // Also check after a short delay (in case of redirect)
//   setTimeout(handlePostRegistrationCart, 2000);
// })();



/**
 * Post Registration Cart Script
 * Adds subscription product to cart after successful registration from member benefits page
 */

(function () {
  'use strict';

  // Subscription product handle
  const SUBSCRIPTION_PRODUCT_HANDLE = 'subscription-product';

  /**
   * Fetch subscription product variant ID
   */
  async function getSubscriptionProductVariant() {
    try {
      const response = await fetch(`/products/${SUBSCRIPTION_PRODUCT_HANDLE}.js`);

      if (!response.ok) {
        console.error('Failed to fetch subscription product:', response.status);
        return null;
      }

      const product = await response.json();

      // Get the first available variant
      const availableVariant = product.variants.find(v => v.available) || product.variants[0];

      if (!availableVariant) {
        console.error('No available variants found for subscription product');
        return null;
      }

      return availableVariant.id;
    } catch (error) {
      console.error('Error fetching subscription product:', error);
      return null;
    }
  }

  /**
   * Add product to cart
   */
  async function addToCart(variantId) {
    try {
      const requestBody = {
        id: variantId,
        quantity: 1
      };
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });


      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
        console.error('addToCart: Failed to add to cart:', errorData);
        return false;
      }

      const cartItem = await response.json();
      return true;
    } catch (error) {
      console.error('addToCart: Error adding to cart:', error);
      return false;
    }
  }

  /**
   * Update cart drawer/mini cart if available
   */
  function updateCartUI() {
    // Dispatch cart update event
    document.dispatchEvent(new CustomEvent('cart:updated'));

    // Try to fetch and update cart drawer
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count if elements exist
        const cartCountElements = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count]');
        cartCountElements.forEach(el => {
          if (el) {
            el.textContent = cart.item_count;
          }
        });

        // Trigger mini-cart refresh if available
        const miniCart = document.querySelector('mini-cart');
        if (miniCart && typeof miniCart.renderContents === 'function') {
          fetch('/cart?sections=mini-cart,cart-icon-bubble')
            .then(res => res.json())
            .then(sections => {
              const parsedState = {
                sections: {
                  'mini-cart': sections['mini-cart'],
                  'cart-icon-bubble': sections['cart-icon-bubble']
                }
              };
              miniCart.renderContents(parsedState);
            })
            .catch(err => console.error('Error updating mini cart:', err));
        }
      })
      .catch(err => console.error('Error fetching cart:', err));
  }

  /**
   * Check if customer is logged in
   */
  function isCustomerLoggedIn() {
    // Check multiple ways to detect logged in customer
    if (typeof window.customer !== 'undefined' && window.customer !== null) {
      return true;
    }

    // Check if we're on account page (but not login/register)
    const path = window.location.pathname;
    const isOnAccountPage = path.includes('/account') &&
      !path.includes('/account/login') &&
      !path.includes('/account/register') &&
      !path.includes('/account/reset');

    if (isOnAccountPage) {
      // Check if customer data is available via DOM
      const hasCustomerElements = document.querySelector('.customer.account') !== null;
      return hasCustomerElements;
    }

    return false;
  }

  /**
   * Check if customer has subscription tags
   */
  function hasSubscription() {
    if (!window.customer || !window.customer.tags) {
      return false;
    }
    
    return window.customer.tags.some(tag => 
      tag === 'Subscription' || tag.startsWith('Subscription-')
    );
  }

  // Flag to prevent multiple simultaneous executions
  let isProcessing = false;

  /**
   * Main function to handle post-registration/login cart addition
   * Adds subscription product after ANY registration or login
   */
  async function handlePostRegistrationCart(attempts = 0) {
    
    // Prevent multiple simultaneous executions
    if (isProcessing) {
      return;
    }

    // Check if user just registered or logged in
    const justRegistered = sessionStorage.getItem('justRegistered') === 'true';
    const justLoggedIn = sessionStorage.getItem('justLoggedIn') === 'true';

    // Also check referrer as backup
    const referrer = document.referrer || '';
    const cameFromRegister = referrer.includes('/account/register');
    const cameFromLogin = referrer.includes('/account/login') && !referrer.includes('/account/register');

    // Check URL parameters for login indicators (Shopify uses customer_posted after login)
    const urlParams = new URLSearchParams(window.location.search);
    const hasCustomerPosted = urlParams.has('customer_posted');
    const hasReturnUrl = urlParams.has('return_url');

    // Check if user is logged in (if they are, and we just came from login page, it's a login)
    const isLoggedIn = isCustomerLoggedIn();
    const isOnAccountPage = window.location.pathname.includes('/account') && 
                            !window.location.pathname.includes('/account/login') &&
                            !window.location.pathname.includes('/account/register');

    // If user is logged in and we have indicators of a recent login, treat it as a login
    const likelyJustLoggedIn = isLoggedIn && (hasCustomerPosted || cameFromLogin || (isOnAccountPage && justLoggedIn));

    // Check if user registered or logged in
    const shouldAddSubscription = justRegistered || justLoggedIn || cameFromRegister || cameFromLogin || likelyJustLoggedIn;

    if (!shouldAddSubscription) {
      return;
    }

    // If we detected a login via URL params but flag wasn't set, set it now
    if (likelyJustLoggedIn && !justLoggedIn && !justRegistered) {
      sessionStorage.setItem('justLoggedIn', 'true');
    }

    // Set processing flag
    isProcessing = true;

    try {

      // Prevent infinite retries
      if (attempts > 10) {
        sessionStorage.removeItem('addSubscriptionAfterRegister');
        sessionStorage.removeItem('fromMemberBenefits');
        sessionStorage.removeItem('justRegistered');
        sessionStorage.removeItem('justLoggedIn');
        isProcessing = false;
        return;
      }

      // Check if user is logged in (registration was successful)
      const isLoggedIn = isCustomerLoggedIn();

      // Wait a bit for customer data to be available after redirect
      if (!isLoggedIn) {
        // Wait and check again (with exponential backoff)
        const delay = Math.min(1000 * (attempts + 1), 5000);
        isProcessing = false; // Reset flag before retry
        setTimeout(() => handlePostRegistrationCart(attempts + 1), delay);
        return;
      }

      // Customer is logged in - check if we should add subscription
      // Determine if this was a login (not registration)
      // Re-check flags in case they were set above
      const currentJustLoggedIn = sessionStorage.getItem('justLoggedIn') === 'true';
      const currentJustRegistered = sessionStorage.getItem('justRegistered') === 'true';
      const isLogin = currentJustLoggedIn || cameFromLogin || likelyJustLoggedIn;
      const isRegistration = currentJustRegistered || cameFromRegister;

      // If this was a login (not registration), check if customer already has subscription
      if (isLogin && !isRegistration) {
        // Wait a bit for customer data to be available
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Check if customer has subscription tags
        // Retry a few times if customer data is not yet available
        let hasSubscriptionTags = false;
        let customerCheckAttempts = 0;
        const maxCustomerChecks = 5;
        
        while (customerCheckAttempts < maxCustomerChecks) {
          
          if (window.customer && window.customer.tags) {
            hasSubscriptionTags = hasSubscription();
            break;
          }
          // Wait a bit more for customer data
          await new Promise(resolve => setTimeout(resolve, 300));
          customerCheckAttempts++;
        }

        // If customer already has subscription, don't add subscription product
        if (hasSubscriptionTags) {
          // Clear the flags
          sessionStorage.removeItem('justRegistered');
          sessionStorage.removeItem('justLoggedIn');
          sessionStorage.removeItem('addSubscriptionAfterRegister');
          sessionStorage.removeItem('fromMemberBenefits');
          isProcessing = false;
          return;
        } else {
        }
      } else {
        console.log('Post-registration: This is a registration, will add subscription product');
      }

      // Customer is logged in and either:
      // 1. This was a registration (new customer won't have subscription)
      // 2. This was a login but customer doesn't have subscription
      // Proceed with adding product to cart
      
      // Small delay to ensure page is fully loaded
      await new Promise(resolve => setTimeout(resolve, 500));

      // Fetch subscription product variant ID
      let variantId;
      try {
        variantId = await getSubscriptionProductVariant();
      } catch (error) {
        console.error('Post-registration: Error fetching variant ID:', error);
        variantId = null;
      }

      if (!variantId) {
        console.error('Post-registration: Could not get subscription product variant ID');
        // Clear flags on error
        sessionStorage.removeItem('justRegistered');
        sessionStorage.removeItem('justLoggedIn');
        sessionStorage.removeItem('addSubscriptionAfterRegister');
        sessionStorage.removeItem('fromMemberBenefits');
        isProcessing = false;
        return;
      }

      // Check if product is already in cart - check multiple times to be sure
      let subscriptionFound = false;
      let retryCount = 0;
      const maxRetries = 3;

      while (!subscriptionFound && retryCount < maxRetries) {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          // Check for subscription product by variant ID (most reliable)
          const subscriptionByVariant = cart.items.find(item => {
            return item.variant_id === variantId ||
              item.variant_id.toString() === variantId.toString();
          });

          // Also check by handle and title as backup
          const subscriptionByHandle = cart.items.filter(item => {
            return item.product_handle === SUBSCRIPTION_PRODUCT_HANDLE ||
              (item.product_title && item.product_title.toLowerCase().includes('membership')) ||
              (item.product_title && item.product_title.toLowerCase().includes('subscription'));
          });

          // Use variant ID match first, then handle match
          const subscriptionItem = subscriptionByVariant || subscriptionByHandle[0];

          if (subscriptionItem) {
            subscriptionFound = true;

            // If quantity is more than 1, update it to 1
            if (subscriptionItem.quantity > 1) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  id: subscriptionItem.key,
                  quantity: 1
                })
              });
              updateCartUI();
            }

            // Clear flags
            sessionStorage.removeItem('justRegistered');
            sessionStorage.removeItem('justLoggedIn');
            sessionStorage.removeItem('addSubscriptionAfterRegister');
            sessionStorage.removeItem('fromMemberBenefits');
            isProcessing = false; // Reset flag before returning
            return; // Exit function - don't add subscription
          } else {
            console.log('Post-registration: Subscription product not found in cart');
          }

          // If not found, wait a bit and retry (cart might not be updated yet)
          if (!subscriptionItem && retryCount < maxRetries - 1) {
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        } catch (error) {
          console.error('Post-registration: Error checking cart:', error);
          if (retryCount < maxRetries - 1) {
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        }

        retryCount++;
      }

      // Add product to cart
      let added = false;
      try {
        added = await addToCart(variantId);
      } catch (error) {
        console.error('Post-registration: Error in addToCart:', error);
        added = false;
      }

      if (added) {
        // Update cart UI
        updateCartUI();

        // Clear flags after successful addition
        sessionStorage.removeItem('justRegistered');
        sessionStorage.removeItem('justLoggedIn');
        sessionStorage.removeItem('addSubscriptionAfterRegister');
        sessionStorage.removeItem('fromMemberBenefits');
      } else {
        console.error('Post-registration: Failed to add subscription product to cart');
      }

      // Reset processing flag
      isProcessing = false;
    } catch (error) {
      console.error('Post-registration: Error in handlePostRegistrationCart:', error);
      isProcessing = false;
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handlePostRegistrationCart);
  } else {
    // DOM already loaded
    handlePostRegistrationCart();
  }

  // Also check after delays (in case of redirect or flag not set yet)
  setTimeout(handlePostRegistrationCart, 1000);
  setTimeout(handlePostRegistrationCart, 2000);
  setTimeout(handlePostRegistrationCart, 3000);
  setTimeout(handlePostRegistrationCart, 5000);

  // Also listen for storage events in case flag is set in another tab/window
  window.addEventListener('storage', function(e) {
    if (e.key === 'justLoggedIn' && e.newValue === 'true') {
      setTimeout(handlePostRegistrationCart, 500);
    }
  });

  // Also check periodically if user is logged in but flag wasn't set
  // This handles cases where form submission didn't trigger the flag
  let checkCount = 0;
  const maxChecks = 10;
  const checkInterval = setInterval(() => {
    checkCount++;
    if (checkCount > maxChecks) {
      clearInterval(checkInterval);
      return;
    }

    const isLoggedIn = isCustomerLoggedIn();
    const hasFlag = sessionStorage.getItem('justLoggedIn') === 'true' || 
                    sessionStorage.getItem('justRegistered') === 'true';
    
    // If user is logged in but no flag, and we're on account page or have customer_posted param
    if (isLoggedIn && !hasFlag) {
      const urlParams = new URLSearchParams(window.location.search);
      const hasCustomerPosted = urlParams.has('customer_posted');
      const isOnAccountPage = window.location.pathname.includes('/account') && 
                              !window.location.pathname.includes('/account/login') &&
                              !window.location.pathname.includes('/account/register');
      
      if (hasCustomerPosted || isOnAccountPage) {
        sessionStorage.setItem('justLoggedIn', 'true');
        handlePostRegistrationCart();
        clearInterval(checkInterval);
      }
    } else if (hasFlag) {
      // Flag exists, stop checking
      clearInterval(checkInterval);
    }
  }, 1000);
})();